import React from 'react';

// Simple placeholder modal if not fully implemented yet
const ContactModal = ({ onClose }: { onClose?: () => void }) => {
  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '8px', maxWidth: '400px', width: '100%' }}>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '12px' }}>Contact Support</h2>
        <p style={{ marginBottom: '16px', color: '#555' }}>
          Please email us at <a href="mailto:support@resitus.com" style={{ color: 'blue' }}>support@resitus.com</a>.
        </p>
        <button 
          onClick={onClose}
          style={{ padding: '8px 16px', backgroundColor: '#eee', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ContactModal;